import { render, staticRenderFns } from "./teacher.vue?vue&type=template&id=53e96e10&scoped=true"
import script from "./teacher.vue?vue&type=script&lang=js"
export * from "./teacher.vue?vue&type=script&lang=js"
import style0 from "./teacher.vue?vue&type=style&index=0&id=53e96e10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e96e10",
  null
  
)

export default component.exports